<tt-page>
    <tt-page-heading ttModel="p2_m_carrierlist" ttTranslate></tt-page-heading>
    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>

<!--<tt-page tt-class="col-xs-12 sp-0">
    <tt-page-heading class="col-xs-12 sp-0" tt-model="p2_m_carrierlist" tt-translate="true"></tt-page-heading>
    <tt-grid class="col-xs-12 p-2 flex-1 height-full" tt-options="vm.grid" ng-if="vm.model.gridReady"></tt-grid>
</tt-page>-->
